import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend).use(initReactI18next);

export const setupI18n = async (
  lang: string,
  overideConfig = {}
): Promise<void> => {
  if (!i18n.isInitialized) {
    await i18n.init({
      lng: lang,
      fallbackLng: 'fr',
      load: 'languageOnly',
      ns: ['translation'],
      defaultNS: 'translation',
      debug: process.env.NODE_ENV !== 'production',
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: `${process.env.RAZZLE_S3_PREFIX}/public/locales/{{lng}}/{{ns}}.json`,
        addPath: `${process.env.RAZZLE_S3_PREFIX}/public/locales/{{lng}}/{{ns}}.missing.json`,
      },
      ...overideConfig,
    });

    moment.locale(lang);
  }
};
